export var InstructorTableCellType;
(function (InstructorTableCellType) {
    InstructorTableCellType["AVAILABLE"] = "available";
    InstructorTableCellType["RESERVED"] = "reserved";
    InstructorTableCellType["PAUSE"] = "pause";
    InstructorTableCellType["KID_SCHOOL"] = "kidSchool";
})(InstructorTableCellType || (InstructorTableCellType = {}));
